import React from "react";

type Props = {};

const CreationSuccessfull = (props: Props) => {
  return <div>CreationSuccessfull</div>;
};

export default CreationSuccessfull;
